'use strict';

import {
    companyGuard, fnErrorMsg, fnToastrFormError, getSelectedCompany, getSelectedRowData,
    printResponse
} from "../jquery-functions-library";
import {element_exists} from "../functions";
import moment from "moment";

export const fnPaySlipSendReminder = (tableName) => {

    const elementName = '.btn-pay-slip-send-reminder';

    if (!element_exists(elementName)) return false;

    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('[name="_token"]').val()}});

    const lang = allLangFiles['pay-slips'].confirm;

    $(document).off('click', elementName).on('click', elementName, function (e) {
        const payslip = JSON.parse($(tableName).DataTable().row($(this).parents('tr')).data().payslip)

        const mailTo = [`${payslip.payroll.month}/${payslip.payroll.year}`];
        const data = {paySlips: [payslip.id], comment: ''};

        const shouldSendMail = mailTo.length > 0;

        const lastSent = payslip.last_reminded_at !== null
            ? moment(payslip.last_reminded_at).format('DD/MM-YYYY')
            : null;

        if (companyGuard() || !shouldSendMail) return toastr.error(lang.error);

        e.preventDefault();

        const url = `/salary/pay-slips/reminder/${getSelectedCompany()}`;

        $.confirm({
            title: lang.title,
            content: lang.involved + '<br>' + mailTo.join(', ') + '<br>' + (lastSent !== null ? (lang.last_reminded_at + lastSent + '<br>') : '') + lang.confirm + '<br>' + `<div class="container"><div class="row"><div class="col-sm-7 col-centered"><div class="form-group m-t-3"><textarea id="pay_slips-reminder-comment" class="form-control bg-white" type="text" placeholder="${lang.comment}" rows="2"></textarea></div></div></div></div>`,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        data.comment = $('#pay_slips-reminder-comment').val();

                        $.ajax({
                            type: 'POST',
                            url: url,
                            data: data,
                            success: function (response) {
                                printResponse(response);
                                $(tableName).ajax.reload(null, false);
                            },
                            error: fnToastrFormError
                        });
                    },
                    text: lang.yes
                },
                Nej: {
                    text: lang.no
                }
            }
        });

    });
};